export type EstadoType = 'PEN' | 'APR' | 'ANU';

export interface OrdenFacturacionDetalle {
  id: number;
  idOrdenFacturacion: number;
  idPresentacion: number;
  idCalibre: number;
  codigoPrecio: number;
  kilos: number;
  precioUnitario: number;
  monto: number;
  precioServicio: number;
  montoServicio: number;
  presentacion?: {
    idPresentacion: number;
    descripcion: string;
  };
  calibre?: {
    idCalibre: number;
    descripcion: string;
  };
}

export interface OrdenFacturacion {
  id: number;
  numero: string;
  idParte: number;
  idCliente: number;
  fechaProceso: string;
  tipoProceso: string;
  numeroMallas: number;
  totalKilos: number;
  subTotal: number;
  detraccion: number;
  totalServicio: number;
  igv: number;
  totalFacturar: number;
  detraccionCliente: number;
  cuotaUnica: number;
  estado: EstadoType;
  observaciones?: string;
  fechaCreacion: string;
  idUsuarioCreacion?: number;
  cliente?: {
    id: number;
    razonSocial: string;
  };
  parte?: {
    id: number;
    numeroComprobante: number;
    fecha: string;
  };
  detalles: OrdenFacturacionDetalle[];
}

export interface OrdenFacturacionState {
  ordenes: OrdenFacturacion[];
  loading: boolean;
  error: string | null;
}

export const estadoLabels: Record<EstadoType, string> = {
  'PEN': 'Pendiente',
  'APR': 'Aprobado',
  'ANU': 'Anulado',
};

export const estadoColors: Record<EstadoType, 'warning' | 'success' | 'error'> = {
  'PEN': 'warning',
  'APR': 'success',
  'ANU': 'error',
};
